module.exports = __webpack_public_path__ + "img/header-icon.cc1bb033.png";